/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {WelcomePageComponent} from './welcome-page.component';
import {WelcomeDataPageComponent} from './welcome-data-page.component';
import {WelcomePoliticalPageComponent} from './welcome-political-page.component';
import _ from 'lodash';


export const HOME_STATE = 'app.home';

export function homeStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider) {
    $stateProvider.state(HOME_STATE, {
      url: '/home',
      resolve: {
        defaultWorkspace: function() {
          const localUserProfile = adnRouterHelper.services.localUserProfile();
          const WorkspaceRegistry = adnRouterHelper.services.workspaceRegistry();

          const app = localUserProfile.getCurrentApp();
          if (app === 'DATA' || app === 'POLITICAL') {
            return;
          }
          return WorkspaceRegistry.getPromise().then(function(workspaces) {
            return _.head(workspaces);
          }).catch(function() {
            // this can be triggered when ad blocker is installed. Keep here to ensure things proceed properly in this case.
          });
        }
      },
      onEnter: function(defaultWorkspace) {
        const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();
        const localUserProfile = adnRouterHelper.services.localUserProfile();
        const $state = adnRouterHelper.services.state();

        const options = {location: false};
        const anyPerms = LocalUserPermissions.getAnyVisibility();
        const app = localUserProfile.getCurrentApp();
        if (app === 'DATA') {
          return $state.target('app.welcome-data', null, options);
        }
        if (app === 'POLITICAL') {
          return $state.target('app.welcome-political', null, options);
        }
        if (anyPerms.MANAGE_ADVERTISING) {
          return defaultWorkspace && defaultWorkspace.id ?
            $state.target('app.wor.workspaces.workspace', {id: defaultWorkspace.id}, options) :
            $state.target('app.welcome', null, options);
        }
        return $state.target('app.welcome', null, options);
      }
    }).state('app.welcome', {
      url: '/welcome',
      views: {
        content: {
          component: WelcomePageComponent
        }
      },
      data: {
        title: 'Welcome to Adnuntius'
      }
    }).state('app.welcome-data', {
      url: '/welcome-data',
      views: {
        content: {
          component: WelcomeDataPageComponent
        }
      }
    }).state('app.welcome-political', {
      url: '/welcome-political',
      views: {
        content: {
          component: WelcomePoliticalPageComponent
        }
      },
      data: {
        app: 'POLITICAL',
        title: 'Welcome — Political'
      }
    });
  }, adnRouterHelper);
}
